import React from 'react';
import InstructorArea from './InstructorArea';

interface InstructorItem {
  data: object
}

interface InstructorsSectionProps {
  data: {
    registerRepeater: InstructorItem[];
  };
}

const InstructorsSection: React.FC<InstructorsSectionProps> = ({ data }) => {
  return (
    <section className="instructor__area-two" style={{ padding: '60px 0 40px' }}>
      <div className="container">
        <div className="instructor__item-wrap-two">
          <div className="row">
            {data?.registerRepeater.map((item, index) => (
              <InstructorArea data={item} key={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstructorsSection;
